export default __webpack_public_path__ + "static/media/sencillo-de-musica.96c6dbc2.svg";